<template>
  <div class="custom-misc-page">
    <div class="content-wrap text-center">
      <h2 class="page-title">We are launching soon 🚀</h2>
      <p class="page-subtitle">Our website is opening soon. Please register to get notified when it's ready!</p>
      <b-form inline class="notify-form justify-content-center" @submit.prevent>
        <b-form-input class="email-input" type="text" placeholder="john@example.com" />
        <b-button variant="primary" class="notify-btn" type="submit">Notify</b-button>
      </b-form>
      <b-img fluid class="hero-image" src="/comingsoon.png" alt="Coming soon page" />
    </div>
  </div>
</template>

<script>
import {
  BForm, BFormInput, BButton, BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BForm,
    BButton,
    BFormInput,
    BImg,
  },
}
</script>

<style scoped lang="scss">
.custom-misc-page {
  min-height: 100vh;
  background: #f7f7fb;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
}

.content-wrap {
  width: min(760px, 100%);
}

.page-title {
  color: #5f6274;
  font-size: clamp(1.8rem, 2.8vw, 2.2rem);
  font-weight: 700;
  margin-bottom: 0.45rem;
}

.page-subtitle {
  color: #8b8f9f;
  font-size: 1rem;
  margin-bottom: 1.1rem;
}

.notify-form {
  margin-bottom: 1.55rem;
  gap: 0.6rem;
}

.email-input {
  width: 100%;
  max-width: 270px;
}

.notify-btn {
  background: #001a3b !important;
  border-color: #001a3b !important;
  padding: 0.55rem 1.2rem !important;
}

.hero-image {
  width: min(620px, 100%);
}
</style>
